import { IOrganisation, ISaveOrganisation, supportApi } from '../../shared';
import { NewBaseClient } from '../../shared/clients/new-base.client';

class OrganisationClient extends NewBaseClient<ISaveOrganisation, IOrganisation> {
    constructor() {
        super(supportApi, '/organisations');
    }
}

export const organisationClient = new OrganisationClient();
